export enum ServerKeys {
  TOTAL_PAX = "TotalDepPAX",
  DY_PAX = "DYPAX",
  DY_PERC = "dy_perc",
  ENTRY_VIA_APP = "DYPAX_ENTRY_APP",
  ENTRY_VIA_KIOSK = "DYPAX_ENTRY_OTDY_KIOSKS",
  AIRPORT = "Airport",
  AIRLINE = "Airline",
  START_DATE = "startDate",
  END_DATE = "endDate",
  YTD = "ytd",
  Date = "Date",
  ENTRY_KIOSK = "entry_kiosk",
  STATUS = "Status",
  MONTH = "MONTH_YEAR",
  YEAR = "Year",
  CUR_GRAPH_TYPE = "CurGraphType"
}
